// src/components/CheckoutStepper/CheckoutStepper.jsx

import React, { useState } from 'react';

export default function CheckoutStepper({
  cart,
  removeFromCart,
  clearCart,
  onComplete,
}) {
  const steps = ['Cart', 'Shipping', 'Payment', 'Confirmation'];
  const [stepIdx, setStepIdx] = useState(0);

  // — Shipping form state —
  const [shippingInfo, setShippingInfo] = useState({
    fullName: '',
    address: '',
    city: '',
    province: '',
    postalCode: '',
  });

  // — Payment form state —
  const [paymentInfo, setPaymentInfo] = useState({
    cardNumber: '',
    expiry: '',
    cvv: '',
  });

  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingInfo((s) => ({ ...s, [name]: value }));
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentInfo((p) => ({ ...p, [name]: value }));
  };

  const next = () => setStepIdx((i) => Math.min(i + 1, steps.length - 1));
  const back = () => setStepIdx((i) => Math.max(i - 1, 0));

  return (
    <div className="checkout-stepper">
      <div className="stepper-header">
        {steps.map((label, i) => (
          <span key={i} className={`step ${i <= stepIdx ? 'step--done' : ''}`}>
            {label}
          </span>
        ))}
      </div>

      <div className="stepper-content">
        {/* Step 0: Cart */}
        {stepIdx === 0 && (
          <div>
            <h3>Your Cart</h3>
            {cart.length === 0 ? (
              <p>Your cart is empty.</p>
            ) : (
              <>
                <ul className="cart-list">
                  {cart.map((p) => (
                    <li key={p.id} className="cart-item">
                      <span>
                        {p.name} — ${p.price.toFixed(2)}
                      </span>
                      <button onClick={() => removeFromCart(p.id)}>
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="cart-actions">
                  <button onClick={clearCart}>Clear Cart</button>
                  <button onClick={next}>Proceed to Shipping</button>
                </div>
              </>
            )}
          </div>
        )}

        {/* Step 1: Shipping */}
        {stepIdx === 1 && (
          <div>
            <h3>Shipping Information</h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                next();
              }}
            >
              {[
                { label: 'Full Name', name: 'fullName' },
                { label: 'Address', name: 'address' },
                { label: 'City', name: 'city' },
                { label: 'Province', name: 'province' },
                { label: 'Postal Code', name: 'postalCode' },
              ].map(({ label, name }) => (
                <label key={name}>
                  {label}:
                  <input
                    name={name}
                    value={shippingInfo[name]}
                    onChange={handleShippingChange}
                    required
                  />
                </label>
              ))}

              <div className="step-actions">
                <button type="button" onClick={back}>
                  Back
                </button>
                <button type="submit">Next</button>
              </div>
            </form>
          </div>
        )}

        {/* Step 2: Payment */}
        {stepIdx === 2 && (
          <div>
            <h3>Payment Details</h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                next();
              }}
            >
              {[
                { label: 'Card Number', name: 'cardNumber', type: 'text' },
                { label: 'Expiry (MM/YY)', name: 'expiry', type: 'text' },
                { label: 'CVV', name: 'cvv', type: 'text' },
              ].map(({ label, name, type }) => (
                <label key={name}>
                  {label}:
                  <input
                    type={type}
                    name={name}
                    value={paymentInfo[name]}
                    onChange={handlePaymentChange}
                    required
                  />
                </label>
              ))}

              <div className="step-actions">
                <button type="button" onClick={back}>
                  Back
                </button>
                <button type="submit">Pay</button>
              </div>
            </form>
          </div>
        )}

        {/* Step 3: Confirmation */}
        {stepIdx === 3 && (
          <div>
            <h3>Order Confirmed!</h3>
            <p>Thank you for your purchase.</p>
            <button onClick={onComplete}>Finish</button>
          </div>
        )}
      </div>
    </div>
  );
}
